<template>
	<div class="grid-container card-list" v-if="cardType == 'skipass'">
		<transition-list>
			<SkipassCard
				v-for="(item, index) in filteredList"
				:cardData="item"
				:index="index"
				:keycardPrice="keycardPrice"
				:key="item.ages[0].poollid"
				class="transition-list-item"
			/>
		</transition-list>
		<div v-if="filteredList.length === 0" class="grid-x cell small-12">
			<div class="card-list__no-results">
				<h2>{{ $t('emptyStates.noResultsHeading') }}</h2>
				<p>{{ $t('emptyStates.noResultsSkipassText') }}</p>
				<Button @click.native="scrollAndFocus()" size="small">
					{{ $t('emptyStates.noResultsButtonText') }}
				</Button>
			</div>
		</div>
	</div>

	<div class="grid-container card-list" v-else-if="cardType === 'skirental'">
		<transition-list>
			<SkirentalCard
				v-for="(item, index) in filteredList"
				:cardData="item"
				:index="index"
				:levels="levels"
				:deliveryPrice="deliveryPrice"
				:key="item.id"
				class="transition-list-item"
			/>
		</transition-list>
		<div v-if="filteredList.length === 0" class="grid-x cell small-12">
			<div class="card-list__no-results">
				<h2>{{ $t('emptyStates.noResultsHeading') }}</h2>
				<p>{{ $t('emptyStates.noResultsSkirentalText') }}</p>
				<Button @click.native="scrollAndFocus()" size="small">
					{{ $t('emptyStates.noResultsButtonText') }}
				</Button>
			</div>
		</div>
	</div>

	<div class="grid-container card-list" v-else-if="cardType === 'skischool'">
		<transition-list>
			<SkischoolCard
				v-for="(item, index) in filteredList"
				:cardData="item"
				:index="index"
				:types="types"
				:levels="levels"
				:key="item.id"
				class="transition-list-item"
			/>
		</transition-list>
		<div v-if="filteredList.length === 0" class="grid-x cell small-12">
			<div class="card-list__no-results">
				<h2>{{ $t('emptyStates.noResultsHeading') }}</h2>
				<p>{{ $t('emptyStates.noResultsSkischoolText') }}</p>
				<Button @click.native="scrollAndFocus()" size="small">
					{{ $t('emptyStates.noResultsButtonText') }}
				</Button>
			</div>
		</div>
	</div>

	<div class="grid-container card-list" v-else-if="cardType === 'activities'">
		<transition-list>
			<ActivitiesCard
				v-for="(item, index) in filteredList"
				:cardData="item"
				:index="index"
				:key="item.id"
				class="transition-list-item"
			/>
		</transition-list>
		<div v-if="filteredList.length === 0" class="grid-x cell small-12">
			<div class="card-list__no-results">
				<h2>{{ $t('emptyStates.noResultsHeading') }}</h2>
				<p>{{ $t('emptyStates.noResultsActivitiesText') }}</p>
				<Button @click.native="scrollAndFocus()" size="small">
					{{ $t('emptyStates.noResultsButtonText') }}
				</Button>
			</div>
		</div>
	</div>
</template>

<script>
import SkipassCard from './SkipassCard'
import SkirentalCard from './SkirentalCard'
import SkischoolCard from './SkischoolCard'
import ActivitiesCard from './ActivitiesCard'
import TransitionList from './../atoms/TransitionList'
import Button from '../atoms/Button'

import store from '../../vueX/store'

export default {
	name: 'CardList',
	components: {
		SkipassCard,
		SkirentalCard,
		SkischoolCard,
		ActivitiesCard,
		TransitionList,
		Button
	},
	props: {
		cards: {
			type: Array
		},
		cardType: {
			type: String
		},
		startDate: {
			type: String
		},
		endDate: {
			type: String
		},
		levels: {
			type: Array
		},
		types: {
			type: Array
		},
		deliveryPrice: {
			type: Number
		},
		keycardPrice: {
			type: Number
		}
	},
	data() {
		return {
			resultLength: 0
		}
	},
	computed: {
		activeFilters() {
			return store.state.productList.selectedFilters
		},
		activeType() {
			return store.state.productList.selectedFilterType
		},
		filteredList() {
			let newList = [...this.cards]

			if (this.activeType) {
				newList = newList.filter(each => {
					return each[this.activeType.type] == this.activeType.id
				})
			}

			// *************************************************************************************
			// 💩 hårdkodat för filter kategorier.... behövs bytes till något mer dynamiskt. förslåt 💩

			//Skipass
			const category = this.activeFilters.filter(
				each => each.type == 'category'
			)

			//Skirental
			const equipmentcategory = this.activeFilters.filter(
				each => each.type == 'equipmentcategory'
			)
			const equipmentlevel = this.activeFilters.filter(
				each => each.type == 'equipmentlevel'
			)

			//Skischool
			const activitycategory = this.activeFilters.filter(
				each => each.type == 'activitycategory'
			)
			const activitylevel = this.activeFilters.filter(
				each => each.type == 'activitylevel'
			)
			const activitytype = this.activeFilters.filter(
				each => each.type == 'activitytype'
			)

			if (category.length) {
				newList = newList.filter(each => {
					let add = false
					for (let i = 0; i < category.length; i++) {
						const filter = category[i]

						if (Array.isArray(each[filter.type])) {
							if (each[filter.type].includes(filter.id)) {
								add = each[filter.type].includes(filter.id)
								break
							}
						} else if (each[filter.type] == filter.id) {
							add = each[filter.type] == filter.id
							break
						}
					}
					return add
				})
			}

			if (equipmentcategory.length) {
				newList = newList.filter(each => {
					let add = false
					for (let i = 0; i < equipmentcategory.length; i++) {
						const filter = equipmentcategory[i]

						if (Array.isArray(each[filter.type])) {
							if (each[filter.type].includes(filter.id)) {
								add = each[filter.type].includes(filter.id)
								break
							}
						} else if (each[filter.type] == filter.id) {
							add = each[filter.type] == filter.id
							break
						}
					}
					return add
				})
			}

			if (equipmentlevel.length) {
				newList = newList.filter(each => {
					let add = false
					for (let i = 0; i < equipmentlevel.length; i++) {
						const filter = equipmentlevel[i]

						if (Array.isArray(each[filter.type])) {
							if (each[filter.type].includes(filter.id)) {
								add = each[filter.type].includes(filter.id)
								break
							}
						} else if (each[filter.type] == filter.id) {
							add = each[filter.type] == filter.id
							break
						}
					}
					return add
				})
			}

			if (activitycategory.length) {
				newList = newList.filter(each => {
					let add = false
					for (let i = 0; i < activitycategory.length; i++) {
						const filter = activitycategory[i]

						if (Array.isArray(each[filter.type])) {
							if (each[filter.type].includes(filter.id)) {
								add = each[filter.type].includes(filter.id)
								break
							}
						} else if (each[filter.type] == filter.id) {
							add = each[filter.type] == filter.id
							break
						}
					}
					return add
				})
			}

			if (activitylevel.length) {
				newList = newList.filter(each => {
					let add = false
					for (let i = 0; i < activitylevel.length; i++) {
						const filter = activitylevel[i]

						if (Array.isArray(each[filter.type])) {
							if (each[filter.type].includes(filter.id)) {
								add = each[filter.type].includes(filter.id)
								break
							}
						} else if (each[filter.type] == filter.id) {
							add = each[filter.type] == filter.id
							break
						}
					}
					return add
				})
			}

			if (activitytype.length) {
				newList = newList.filter(each => {
					let add = false
					for (let i = 0; i < activitytype.length; i++) {
						const filter = activitytype[i]

						if (Array.isArray(each[filter.type])) {
							if (each[filter.type].includes(filter.id)) {
								add = each[filter.type].includes(filter.id)
								break
							}
						} else if (each[filter.type] == filter.id) {
							add = each[filter.type] == filter.id
							break
						}
					}
					return add
				})
			}

			// *************************************************************************************

			// Slice array to prevent sending to much data to GTM

			if (this.cardType == 'skipass') {
				store.dispatch('GTM_PUSH_SKIPASS_SEARCH', {
					payload: [...newList.slice(0, 10)],
					searchFilters: {
						startDate: this.startDate,
						dateRange: this.activeType ? this.activeType.label : ''
					}
				})
			}

			if (this.cardType == 'skirental') {
				store.dispatch('GTM_PUSH_SKIRENTAL_SEARCH', {
					payload: { items: [...newList.slice(0, 10)], levels: this.levels },
					searchFilters: {
						startDate: this.startDate,
						endDate: this.endDate
					}
				})
			}

			if (this.cardType == 'skischool') {
				store.dispatch('GTM_PUSH_SKISCHOOL_SEARCH', {
					payload: { items: [...newList.slice(0, 30)], levels: this.levels },
					searchFilters: {
						startDate: this.startDate,
						endDate: this.endDate
					}
				})
			}

			// if (this.cardType == 'activities') {
			// 	store.dispatch('GTM_PUSH_SKISCHOOL_SEARCH', {
			// 		payload: { items: [...newList.slice(0, 30)], levels: this.levels },
			// 		searchFilters: {
			// 			startDate: this.startDate,
			// 			endDate: this.endDate
			// 		}
			// 	})
			// }

			return newList
		}
	},
	methods: {
		scrollAndFocus() {
			window.scrollTo(0, 0)
			this.$emit('openDatepicker')
		}
	}
}
</script>

<style scoped lang="scss">
.card-list__no-results {
	margin: 5px 0 0 0;
	max-width: 360px;
	h2 {
		margin-bottom: 5px;
		font-size: 22px;
	}
	p {
		margin-bottom: 18px;
		font-size: 14px;
	}
	@media (min-width: 640px) {
		margin: 40px 0 0 0;
		h2 {
			margin-bottom: 15px;
			font-size: 36px;
		}
		p {
			margin-bottom: 30px;
			font-size: 14px;
		}
	}
}
</style>
